import { defineComponent as _defineComponent } from 'vue'
import { iconProps } from './icon';


export default /*#__PURE__*/_defineComponent({
  __name: 'icon',
  props: iconProps,
  setup(__props) {

const props = __props



return { __sfc: true,props }
}

})